<template>
  <div v-if="influencer">
    <!-- Form -->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-expansion-panels v-model="openExpansion" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header class="title">Contact Information *</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col xs="12" md="6" v-if="influencer.facebook">
              <v-text-field
                class="purple-input"
                label="Facebook Handle"
                v-model="influencer.facebook.handle"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.twitter">
              <v-text-field
                class="purple-input"
                label="X (Twitter) Handle"
                v-model="influencer.twitter.twitterHandle"
              >
                <template v-slot:prepend-inner>
                  <img src="/static/img/x-logo.svg" width="20px" class="mr-2" alt="" aria-hidden="true" />
                </template>
              </v-text-field>
            </v-col>
            <v-col xs="12" md="6" v-if="hasFirstName">
              <v-text-field
                class="purple-input"
                label="First Name"
                v-model="influencer.firstName"
                required
                :rules="MessageRules"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="hasLastName">
              <v-text-field
                class="purple-input"
                label="Last Name"
                v-model="influencer.lastName"
              />
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Email Address"
                class="purple-input"
                v-model="influencer.email"
                @keydown.space.prevent 
                @input="removeSpaces" 
                @paste="preventPasteSpaces" 
                required
                :rules="MessageRules"
              />
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Contact Number"
                class="purple-input"
                v-model="influencer.phone"
              />
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="title">Billing Information</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col xs="12" md="6">
              <v-autocomplete
                v-model="influencer.country"
                label="Country"
                :items="countries"
                item-text="name"
                item-value="name"
                @change="changeCountry"
              >
                <!-- :error-messages="countryErrors"
                required
                @input="$v.influencer.country.$touch()"
                @blur="$v.influencer.country.$touch()"-->
              </v-autocomplete>
            </v-col>
            <v-col xs="12" md="6">
              <!-- <v-text-field
                label="Name of Bank"
                class="purple-input"
                v-model="influencer.bankName"
              /> -->
              <v-combobox
                v-model="influencer.bankName"
                :items="bankNames"
                label="Bank Name (select your bank)"
                item-text="bank"
                item-value="bank"
                :search-input.sync="newBankName"
                attach
                :disabled="disableBankSelect"
                @change="changeBankName"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <span class="subheading pr-2" v-if="newBankName">{{ newBankName }}</span>
                  </v-list-item>
                </template>
              </v-combobox>
              <!-- <v-select
                v-model="influencer.bankName"
                label="Name of Bank"
                :items="bankAccounts"
                item-text="bank"
                item-value="bank"
                @change="changeBankName"
              >
              </v-select> -->
              <!-- :error-messages="bankNameErrors"
                required
                @input="$v.influencer.bankName.$touch()"
              @blur="$v.influencer.bankName.$touch()"-->
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Bank Account Number (Please omit dash '-')"
                class="purple-input"
                v-model="influencer.bankAccount"                      
                v-mask="'################'"                    
              />
              <span></span>
              <!-- :error-messages="bankAccountErrors"
                required
                @input="$v.influencer.bankAccount.$touch()"
              @blur="$v.influencer.bankAccount.$touch()"-->
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Swift Code"
                class="purple-input"
                v-model="swiftCode"                  
              />
              <span></span>
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Fullname as per Bank Account Name"
                class="purple-input"
                v-model="influencer.fullName"
              />
              
              <!-- :error-messages="fullNameErrors"
                required
                @input="$v.influencer.fullName.$touch()"
              @blur="$v.influencer.fullName.$touch()"-->
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Street Address"
                class="purple-input"
                v-model="influencer.mailingAddress"
              />
              <!-- required
                :error-messages="mailingAddressErrors"
                @input="$v.influencer.mailingAddress.$touch()"
              @blur="$v.influencer.mailingAddress.$touch()"-->
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Postal Code"
                class="purple-input"
                v-model="influencer.postalCode"
              />
              <!-- :error-messages="fullNameErrors"
                required
                @input="$v.influencer.fullName.$touch()"
              @blur="$v.influencer.fullName.$touch()"-->
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="title">
            <p>Your rates
              <span class="caption">(in SGD per item)</span>
            </p>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col xs="12" md="4">
              <v-text-field
                label="IG Static"
                class="purple-input"
                v-model.number="influencer.inputedRates.igStatic"
                type="number"
              />
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field
                label="IG Carousel"
                class="purple-input"
                v-model.number="influencer.inputedRates.igCarousel"
                type="number"
              />
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field
                label="IG Story"
                class="purple-input"
                v-model.number="influencer.inputedRates.igStory"
                type="number"
              />
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field
                label="IG TV"
                class="purple-input"
                v-model.number="influencer.inputedRates.igTv"
                type="number"
              />
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field
                label="Tiktok"
                class="purple-input"
                v-model.number="influencer.inputedRates.tiktok"
                type="number"
              />
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field
                label="Blog"
                class="purple-input"
                v-model.number="influencer.inputedRates.blog"
                type="number"
              />
            </v-col>
            <!-- <v-col xs="12" md="6">
              <v-file-input
                show-size
                label="Your Pricing Deck (If any)"
                ref="pricingDeck"
                @change="pricingDeckUpload"
              ></v-file-input>
            </v-col> -->
            <v-col xs="12" md="12">
              Pricing Decks:
                <v-btn                      
                color="blue-grey"
                class="ma-5 white--text"
                @click="$refs.mediaUpload.click()"                 
              >
                Upload
                <v-icon
                  right
                  dark
                >
                  mdi-cloud-upload
                </v-icon>
              </v-btn>
              <input
                  type="file"
                  name="media"
                  style="display: none"
                  ref="mediaUpload"
                  id="fileToUpload"
                  accept="image/*, .pdf, .ppt, .txt, .doc, .docx"
                  @change="prepareUpload"
                />
                <div>
                  <v-row v-if="images.length > 0">
                    <v-col
                      v-for="(img, index) in images"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12" sm="12" md="2" lg="1"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <v-card
                          flat
                          tile
                          class="d-flex"                              
                          :elevation="hover ? 16 : 2"
                        >
                          <v-img                                  
                            :src="img.url"
                            :lazy-src="img.url"                                  
                            class="grey lighten-2"
                            aspect-ratio="1"
                          ></v-img>
                          <v-overlay absolute>
                            <v-btn dark icon @click="deleteImage(index)">
                              <v-icon dark color="red">cancel</v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                  <v-row v-if="decksFiles.length > 0" >
                    <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                      <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                        <v-img
                            width="67" height="85"
                            src="./static/img/pdf.png"
                            aspect-ratio="1"
                          ></v-img>
                      </a>                                                                                                               
                      <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                        <v-img
                            width="67" height="85"
                            src="./static/img/ppt.png"
                          ></v-img>
                      </a>
                      <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                        <v-img
                            width="67" height="85"
                            src="./static/img/doc.png"
                          ></v-img>
                      </a>
                      <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                        <v-img
                            width="67" height="85"
                            src="./static/img/text.png"
                          ></v-img>
                      </a>                        
                      <v-btn dark icon @click="deleteFile(index)">
                        <v-icon dark color="red">cancel</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
            </v-col>
            <v-col xs="12" md="12">
              <v-textarea
                filled
                auto-grow
                class="purple-input"
                label="Remark"
                placeholder="If you have any thoughts on your rates, please let us know here."
                v-model="influencer.inputedRates.remark"
              />
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="title">Additional</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col xs="12" md="6" v-if="influencer.xiaohongshu && isMainPlatform('xiaohongshu')">
              <v-text-field
                label="Followers"
                class="purple-input"
                type="number"
                v-model="influencer.xiaohongshu.totalFollowers"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.xiaohongshu && isMainPlatform('xiaohongshu')">
              <v-text-field
                label="Following"
                class="purple-input"
                type="number"
                v-model="influencer.xiaohongshu.totalFollowing"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.xiaohongshu && isMainPlatform('xiaohongshu')">
              <v-text-field
                label="Likes/Favourites"
                class="purple-input"
                type="number"
                v-model="influencer.xiaohongshu.totalLikesFavourites"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.facebook && isMainPlatform('facebook')">
              <v-text-field
                label="Followers"
                class="purple-input"
                type="number"
                v-model="influencer.facebook.totalFollowers"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.facebook && isMainPlatform('facebook')">
              <v-text-field
                label="Following"
                class="purple-input"
                type="number"
                v-model="influencer.facebook.totalFollowing"
              />
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.linkedin && isMainPlatform('linkedin')">
              <v-text-field
                label="Followers (Connections)"
                class="purple-input"
                type="number"
                min="0"
                v-model.number="influencer.linkedin.totalFollowers"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="#0A66C2" class="mr-2" small>mdi-linkedin</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.twitter && isMainPlatform('twitter')">
              <v-text-field
                label="X (Twitter) Followers"
                class="purple-input"
                type="number"
                min="0"
                v-model.number="influencer.twitter.totalFollowers"
              >
                <template v-slot:prepend-inner>
                  <img src="/static/img/x-logo.svg" width="20px" class="mr-2" alt="" aria-hidden="true" />
                </template>
              </v-text-field>
            </v-col>
            <v-col xs="12" md="6" v-if="influencer.twitter && isMainPlatform('twitter')">
              <v-text-field
                label="X (Twitter) Following"
                class="purple-input"
                type="number"
                min="0"
                v-model.number="influencer.twitter.totalFollowing"
              >
                <template v-slot:prepend-inner>
                  <img src="/static/img/x-logo.svg" width="20px" class="mr-2" alt="" aria-hidden="true" />
                </template>
              </v-text-field>
            </v-col>
            <v-col xs="12" md="6">
              <v-select
                label="Gender"
                :items="userGender_options"
                item-text="text"
                item-value="value"
                v-model="influencer.gender"
              ></v-select>
            </v-col>
            <v-col xs="12" md="6">
              <v-menu
                v-model="bdPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="influencer.birthday"
                    label="Your Birthday"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="influencer.birthday" @input="bdPicker = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col xs="12" md="6">
              <v-select
                label="Ethnicity"
                :items="ethnicity_options"
                item-text="text"
                item-value="value"
                v-model="influencer.ethnicity"
              ></v-select>
            </v-col>
            <v-col xs="12" md="6">
              <v-text-field
                label="Occupation"
                class="purple-input"
                v-model="influencer.occupation"
              />
            </v-col>
            <v-col xs="12" md="12">
              <!-- <v-textarea
                class="purple-input"
                label="Keywords be surface"
                placeholder="(as many as you’d like!) Brands, interests (food, skincare, art, photography, fitness, etc.), race, nationality,
                family condition (kids, parents, grandparents), occupation (office, entrepreneur, expat, home cook, parents),
                life stage (pregnant, bto, first jobber), health condition (myopia, pimples, oily hair)"
                v-model="influencer.keywords"
              /> -->
              <label>Preferred type of campaigns/genre (please tick relevant)</label>
              <v-chip-group multiple active-class="secondary white--text" v-model="influencer.keywords" max="3" column>
                <v-chip v-for="(item, index) in categories" :key="index" :value="item"      
                  class="ma-2"                               
                  filter                                                                                                                                                             
                >
                  {{item}}
                </v-chip>
              </v-chip-group>
            </v-col>
            <!-- <v-col xs12>
              <p
                class="subtitle-1"
              >Please let us know if you used any other social platforms:</p>
              <v-tabs v-model="tab" show-arrows grow icons-and-text>
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                  v-for="(platform, i) in socialPlatforms"
                  :href="'#tab-' + i"
                  :key="i"
                >
                  {{platform.label}}
                  <v-avatar>
                    <img :src="platform.icon" :alt="platform.label" />
                  </v-avatar>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-for="(platform, i) in socialPlatforms"
                  :key="i"
                  :value="'tab-' + i"
                >
                  <v-card flat>
                    <v-card-text>
                      <v-text-field
                        filled
                        :placeholder="platform.placeholder"
                        :label="platform.label"
                        v-model="influencer.selectedSocialPlatforms[i].value"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions class="mt-5 pr-0">
        <v-spacer></v-spacer>
        <v-btn @click="close">Close</v-btn>
        <v-btn id="btn-save-change" color="green" @click="editInfluencer">Save changes</v-btn>
      </v-card-actions>
    </v-form> 
    <!-- Footer -->
    <!-- <v-card-actions style="margin-right:20px;">
      <v-btn @click="close">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="editInfluencer">Save changes</v-btn>
    </v-card-actions> -->
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config';
import Loading from 'vue-loading-overlay';
import userAPIs from '../User/userAPIs';
import influencerAPIs from '../Influencer/influencerAPIs'
import utils from '@/utils';
import Jimp from 'jimp';
import countries from '../../../../static/sources/countries';
import bankAccounts from '../../../../static/sources/bank_accounts';
import swiftCodes from '../../../../static/sources/swift_codes';
import influencerHelper from './influencerHelper'
// import $ from 'jquery'
// import { required, numeric, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'EditInfluencerModal',
  components: {
    Loading
  },
  props: [
    'value',
    'modalId',
    'influencerData',
    'processEdit'
  ],
  data () {
    return {
      valid: true,
      countries: [],
      bankAccounts: [],
      swiftCodes: [],
      userGender_options: [],
      ethnicity_options: [
        {
          value: 'chinese',
          text: 'Chinese'
        },
        {
          value: 'malay',
          text: 'Malay'
        },
        {
          value: 'Indian',
          text: 'indian'
        },
        {
          value: 'eurasian',
          text: 'Eurasian'
        },
        {
          value: 'others',
          text: 'Others'
        }
      ],
      inputedRates: {
        igStatic: null,
        igCarousel: null,
        igStory: null,
        igTv: null,
        tiktok: null,
        blog: null,
        loadingFee: null,
        remark: '',
        pricingDecks: []
      },
      openExpansion: [0, 1, 2, 3],
      influencer: null,
      swiftCode: '',
      isLoading: false,
      disableBankSelect: false,
      bankNames: [],
      pricingDecksMedia: [],
      images: [],
      decksFiles: [],
      deleteObjectKeys: [],
      MessageRules: [value => !!value || 'Required.'],
      categories: influencerHelper.getCategories()
    }
  },
  watch: {
    influencerData: function (newInfluencerData) {
      if (!newInfluencerData) return
      this.influencer = Object.assign({}, newInfluencerData)
      this.influencer.inputedRates = {}
      this.swiftCode = this.influencer.swiftCode || ''
      if (this.influencer.xiaohongshu) {
        if (this.influencer.xiaohongshu.xiaohongshu) {
          this.influencer.xiaohongshu = this.influencer.xiaohongshu.xiaohongshu
        }
      }
      // Retrieve user profile
      this.getUserProfile();
    },
    processEdit: function (newProcessEdit) {
      if (newProcessEdit) {
        // this.editInfluencer()
        // $('btn-save-change').click()
      }
    }
  },
  computed: {
    hasFirstName() {
      if (this.influencer && (this.influencer.firstName || this.influencer.firstName === '')) {
        return true
      }
      return false
    },
    hasLastName() {
      if (this.influencer && (this.influencer.lastName || this.influencer.lastName === '')) {
        return true
      }
      return false
    }
  },
  methods: {
    isMainPlatform(platform) {
      const mainPlatform = String((this.influencer && (this.influencer.activePlatform || this.influencer.platform)) || '').toLowerCase()
      if (!mainPlatform) return true
      return mainPlatform === platform || (platform === 'xiaohongshu' && mainPlatform === 'xhs')
    },
    editInfluencer: function () {
      if (!this.$refs.form.validate()) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please fill the required information correctly.'
        });
        return;
      }
      this.$emit('showLoading', true)
      if (this.influencer.email) {
        this.influencer.email = this.influencer.email.toLowerCase()
      }
      if (typeof this.influencer.bankName === 'object') {
        this.swiftCode = this.influencer.bankName.swift_code || ''
        this.influencer.bankName = this.influencer.bankName.bank
      }
      let edittingUserProfile = Object.assign({}, this.influencer);
      edittingUserProfile.firstName = edittingUserProfile.firstName || ''
      edittingUserProfile.lastName = edittingUserProfile.lastName || ''
      edittingUserProfile.email = (this.influencer.email || '').trim();
      edittingUserProfile.swiftCode = this.swiftCode
      edittingUserProfile.inputedRates = this.inputedRates
      delete edittingUserProfile.audience
      delete edittingUserProfile.tiktokaudience
      delete edittingUserProfile.instagram
      delete edittingUserProfile.tiktok
      let formData = new FormData();
      // Make sure the images appended at bottom
      formData.append('editProfile', JSON.stringify(edittingUserProfile));
      let files = this.pricingDecksMedia;
      for (let val of files) {
        formData.append('deckFile', val);
      }
      // Edit influencer
      userAPIs.editInfluencerFromAdmin(formData)
        .then(response => {
          this.$emit('showLoading', false);
          if (this.deleteObjectKeys.length > 0) {
            this.deleteObjectKeys.map(item => {
              api.request('delete', '/api/v1/posts/s3/delete', true, {image: item})
            })
          }
          // Return the newly added data to parent component
          this.$emit('editInfluencer', response)

          // Dismiss modal by triggering the click event on Close button
          this.close()
          this.$swal({
            text: 'Influencer Updated',
            type: 'success'
          });
          this.deleteObjectKeys = []
          this.getUserProfile()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
          this.$emit('showLoading', false);
        })
    },
    getUserProfile() {
      if (!this.influencer.userID) {
        return;
      }
      userAPIs
        .getUser(this.influencer.userID)
        .then(response => {
          this.images = []
          this.decksFiles = []
          if (response.influencer.inputedRates) {
            this.inputedRates = {
              igStatic: response.influencer.inputedRates['igStatic'],
              igCarousel: response.influencer.inputedRates['igCarousel'],
              igStory: response.influencer.inputedRates['igStory'],
              igTv: response.influencer.inputedRates['igTv'],
              tiktok: response.influencer.inputedRates['tiktok'],
              blog: response.influencer.inputedRates['blog'],
              loadingFee: response.influencer.inputedRates['loadingFee'],
              remark: response.influencer.inputedRates['remark'],
              pricingDecks: response.influencer.inputedRates['pricingDecks']
            }

            // Add pricingDecks images
            if (this.inputedRates.pricingDecks.length > 0) {
              this.inputedRates.pricingDecks.map(item => {
                let mediaType = item.type.split('/')[0];
                if (mediaType === 'image') {
                  this.images.push(item)
                } else {
                  this.decksFiles.push(item)
                  // this.pricingDecksMedia.push(item)
                }
              })
            }
          }
          this.influencer.firstName = response.firstName
          this.influencer.lastName = response.lastName
          this.influencer.fullName = response.influencer.fullName
          this.influencer.country = response.influencer.country
          this.influencer.bankName = response.influencer.bankName
          this.swiftCode = response.influencer.swiftCode || this.influencer.swiftCode || ''
          this.influencer.swiftCode = this.swiftCode
          this.changeCountry()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let mediaType = element.type.split('/')[0];
        let fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buffer = e.target.result;
            Jimp.read(buffer, (err, img) => {
              if (err) console.error(111, err);
              img
                .resize(500, Jimp.AUTO)
                .quality(100)
                .getBase64(Jimp.MIME_PNG, (err, buff) => {
                  if (err) console.error(222, err);
                  let file = utils.func.dataURLtoFile(buff, element.name);
                  this.pricingDecksMedia.push(file);
                  this.images.push({
                    url: buff,
                    src: buff,
                    name: element.name
                  });
                });
            });
          };
          // reset the input
          e.target.value = '';
        } else {
          this.decksFiles.push(element);
          this.pricingDecksMedia.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage(imgIndex) {
      let imgURl = this.images[imgIndex].url;
      // console.log('🚀 ~ file: Profile.vue ~ line 983 ~ deleteImage ~ this.images', this.images)
      let filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1)
      // console.log('🚀 ~ file: Profile.vue ~ line 977 ~ deleteImage ~ imgName', imgURl)
      this.deleteObjectKeys.push(filename)
      this.images.splice(imgIndex, 1)

      let pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(item => item.url === imgURl)
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1)

      let inputRateIndex = this.inputedRates.pricingDecks.findIndex(item => item.url === imgURl)
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1)
    },
    deleteFile(fileIndex) {
      let fileURL = ''
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        let fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1)
        this.deleteObjectKeys.push(fileName)
      }
      this.decksFiles.splice(fileIndex, 1)
      // console.log('🚀 ~ file: Profile.vue ~ line 983 ~ deleteFile ~ this.deleteObjectKeys', this.deleteObjectKeys)
      let pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(item => item.url === fileURL)
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1)

      let inputRateIndex = this.inputedRates.pricingDecks.findIndex(item => item.url === fileURL)
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1)
    },
    close: function () {
      this.$emit('closeModal');
    },
    changeBankName(selectedValue) {
      this.swiftCode = ''
      const selectedBank = selectedValue || this.influencer.bankName
      if (selectedBank && typeof selectedBank === 'object' && selectedBank.swift_code) {
        this.swiftCode = selectedBank.swift_code
        this.influencer.swiftCode = this.swiftCode
        return
      }
      let bank = ''
      if (selectedBank && selectedBank.bank) {
        bank = selectedBank.bank
      } else {
        bank = selectedBank
      }
      let matchBank = this.bankNames.find(b => b.bank === bank)
      if (matchBank) {
        this.swiftCode = matchBank.swift_code || ''
        this.influencer.swiftCode = this.swiftCode
        return
      }
      matchBank = this.swiftCodes.find(b => b.bank === bank)
      if (matchBank) {
        this.swiftCode = matchBank.code
      } else {
        const legacyBank = this.bankAccounts.find(b => b.bank === bank)
        if (legacyBank) {
          this.swiftCode = legacyBank.code
        }
      }
      this.influencer.swiftCode = this.swiftCode
    },
    async changeCountry() {
      try {
        this.bankNames = []
        let country = this.countries.find(c => c.name === this.influencer.country)
        if (!country) {
          return;
        }
        this.disableBankSelect = true
        await this.getBanks(country.code)
        let matchBank = this.allBanks.find(bank => bank.country_code === country.code)
        if (matchBank && matchBank.list !== undefined) {
          this.bankNames = matchBank.list.filter(bank => bank.branch === null)
          if (!this.swiftCode && this.influencer.bankName) {
            const bankName = typeof this.influencer.bankName === 'object'
              ? this.influencer.bankName.bank
              : this.influencer.bankName
            const selectedBank = this.bankNames.find(bank => bank.bank === bankName)
            if (selectedBank) {
              this.swiftCode = selectedBank.swift_code || ''
              this.influencer.swiftCode = this.swiftCode
            }
          }
        }
        this.disableBankSelect = false
      } catch (err) {
        console.log(err)
        this.bankNames = []
        this.disableBankSelect = false
      }
    },
    async getBanks(code) {
      try {
        this.allBanks = await influencerAPIs.getBanks(code)
      } catch (error) {
        console.log('error', error);
      }
    },
    // Remove spaces after input (to clear spaces if pasted somehow)
    removeSpaces() {
      this.influencer.email = this.influencer.email.replace(/\s/g, '');
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  },
  mounted() {
    // Retrieve gender config
    this.userGender_options = config.userGenderDisplay;

    // Retrieve countries manually
    this.countries = countries;

    // Retrive bank accounts manually
    this.bankAccounts = bankAccounts

    // Retrieve swift code manullay
    this.swiftCodes = swiftCodes
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// EditInfluencerModal.vue?8c4984a8